import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { InputAdornment } from "@mui/material";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { LEYES } from "consts/leyes";
import { RNHConvenioIns } from "services/services-mia/programa-salud/personal/RNHConvenioIns";

/**
 * Alta de un convenio: código, ley y carga semanal.
 */
export default function InsertModal({ updateList, closeModal }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  const crearConvenio = async (values) => {
    setInRequest(true);
    const respuesta = await RNHConvenioIns(credentials, {
      cod: values.cod,
      ley: values.ley,
      cargaSemanal: values.cargaSemanal,
    });
    setInRequest(false);

    if (!respuesta.ok) return;

    setSnackBarInfo({
      message: "Régimen horario creado correctamente",
      severity: "success",
      open: true,
    });
    formikRef.current.resetForm();
    updateList();
    closeModal();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        cod: "",
        ley: "",
        cargaSemanal: "",
      }}
      validationSchema={yup.object({
        cod: yup
          .string()
          .max(LARGO.cod, mensajeLargo(LARGO.cod))
          .required("Debe ingresar un código"),
        ley: yup
          .string()
          .oneOf(LEYES.map(({ cod }) => cod))
          .required("Debe seleccionar la ley"),
        cargaSemanal: yup
          .string()
          // \d* y no \d+ para que el vacio caiga en el required y no en este mensaje.
          .matches(/^\d*$/, "Solo números")
          .test(
            "rango",
            "Debe estar entre 0 y 168 hs",
            (valor) => !valor || Number(valor) <= 168
          )
          .required("Debe ingresar la carga semanal"),
      })}
      onSubmit={(values) => {
        crearConvenio(values);
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={4}>
              <FormikTextInput
                fullWidth={true}
                name="cod"
                labelText="Código"
                  inputProps={{ maxLength: LARGO.cod }}
              />
            </Grid>
            <Grid item xs={4}>
              <FormikSelectInput
                fullWidth={true}
                name="ley"
                labelText="Ley"
              >
                <option value="" disabled>
                  Seleccione
                </option>
                {LEYES.map(({ cod, label }) => (
                  <option key={cod} value={cod}>
                    {label}
                  </option>
                ))}
              </FormikSelectInput>
            </Grid>
            <Grid item xs={4}>
              <FormikTextInput
                fullWidth={true}
                name="cargaSemanal"
                labelText="Carga semanal"
                inputProps={{ maxLength: 3, inputMode: "numeric" }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">hs</InputAdornment>,
                }}
                onChange={(e) =>
                  formikRef.current.setFieldValue(
                    "cargaSemanal",
                    e.target.value.replace(/\D/g, "")
                  )
                }
              />
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Crear" }}
            onCloseModal={closeModal}
          />
          {(inRequest) && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
